import { PROFILE_CLS } from "./constants";

export const extractProfileFromRawSnapshot = (
  userSnapshot: Record<string, any>
): Record<string, any> | null => {
  const primaryGroup = userSnapshot.groups.find((group) => group.name === "Primary");
  if (primaryGroup?.nestedObjects) {
    return primaryGroup.nestedObjects.find(
      (obj) => obj.id === userSnapshot.address && obj["class"] === PROFILE_CLS
    );
  }

  return null;
};
